import FormControlClient from "./FormControl.client.js";
import FormControlError from "./FormControlError.js";
import FormControlHelper from "./FormControlHelper.js";
import FormControlLabel from "./FormControlLabel.js";
/**
 * Keeping the compound component composition inside a server component to make sure
 * frameworks like Next.js won't require use client to be added on the product side
 */
const FormControl = FormControlClient;
FormControl.Label = FormControlLabel;
FormControl.Helper = FormControlHelper;
FormControl.Error = FormControlError;
export default FormControl;
